// The Web Share API signals a dismissed sheet with an AbortError; Capacitor's
// Share plugin rejects with a plain "Share canceled" error on both iOS and
// Android. Either way the user chose not to share, so nothing should fall back.
export function isShareCancel(err: unknown): boolean {
  if (err instanceof DOMException && err.name === 'AbortError') return true
  return err instanceof Error && err.message === 'Share canceled'
}
